module.exports = __webpack_public_path__ + "img/logo_qclass_agenda.b3e29c86.png";